import React from 'react';
import { ComponentWrapper } from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const Intro = props => {
  const { intro } = props;
  return (
    <div className="tsw-c-intro position-relative margin-bottom-xl">
      <div className="text-center">
        <div className="intro-bg d8-u-bg-img width-100% position-absolute" style={{ backgroundImage: `url(${intro.bgimage})`, height: '60%' }} />
        <div className="padding-top-xl">
          <ComponentWrapper>
            <h2 className="text-center margin-bottom-md max-width-xxxxs margin-auto position-relative">
              {intro.title}
            </h2>
            <div className="max-width-sm margin-auto">
              <div className="position-relative">
                <iframe
                  src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/388101275&color=%2300a9a3&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
                  scrolling="no"
                  width="100%"
                  height="166"
                  frameBorder="no"
                  title="TSW - The Story So Far"
                />
              </div>
              {/* <Card
                template="ImageCard"
                size="aspect-16-9"
                imageCardTemplate="Horizontal"
                video={intro.card.video}
                bgImage={intro.card.image}
                overlay
              /> */}
              {intro.text && <div className="max-width-xxxs margin-auto text-center margin-top-md"><p>{intro.text}</p></div>}
            </div>
          </ComponentWrapper>
        </div>
      </div>
    </div>
  );
};


Intro.propTypes = {
  intro: PropTypes.object
};

export default Intro;
